export default __webpack_public_path__ + "static/media/groundsupport.b612f880.png";